import { call,all, takeEvery, put, select, takeLatest, delay } from 'redux-saga/effects';
import {
    CoachReportsActionTypes,
    changeLoading,
    changeReports,
    changeLoadingGenerate,
    updateCoachReports,
    reportsPolling,
    updateReports,
    changeParams,
} from '../reducers/coach-reports.reducer';
import { generateCoachReport, getCoachReports, deleteReport } from '../utils/webApi';
import handleError from '../utils/handleError';
import { IState } from '../reducers/reducers';
import { ReportStatus, IChangedReports, IReport } from '../models/report.model';
import { isEmpty } from '../utils/utils.functions';
import { requestUserData } from '../reducers/reports.reducer';

function* requestReports() {
    try {
        const { status, order_by, page, pageSize, to, from } = yield select((state: IState) => state.coachReports);
        yield put(changeLoading(true));
        const { reports, total } = yield call(getCoachReports, {
            status: status ? [status] : undefined,
            page,
            pageSize,
            order_by,
            to: to ? new Date(to) : undefined,
            from: from ? new Date(from) : undefined
        });

        yield put(changeReports(reports));
        yield put(changeParams({total}));

        yield put(reportsPolling());
        yield put(requestUserData());
    } catch (error) {
        handleError(error);
    } finally {
        yield put(changeLoading(false));
    };
};

function* requestGenerateReport() {
    try {
        yield put(changeLoadingGenerate(true));
        const { reports, pageSize, isPolling, total } = yield select((state: IState) => state.coachReports);
        const report: IReport = yield call(generateCoachReport);
        const newReports = [{...report, isLocal: true}, ...reports].slice(0, pageSize);

        yield put(changeReports(newReports));
        yield put(changeParams({total: total + 1}))

        if(!isPolling) {
            yield put(reportsPolling());
        }

    } catch (err) {
        handleError(err);
    } finally {
        yield put(changeLoadingGenerate(false));
    };
};

function* pollingForStatus() {
    try {
        const processingKeys = [ReportStatus.CREATED, ReportStatus.PROCESSING];

        yield delay(4000);

        const { reports } = yield select((state: IState) => state.coachReports);
        const processingLocalReports = reports.filter((r: IReport) => processingKeys.includes(r.status));

        if(processingLocalReports.length > 0) {
            const response: {reports: IReport[]} = yield call(getCoachReports, {status: processingKeys, page:1, pageSize: 1000});
            let changedReports: IChangedReports = {};
            for (let report of processingLocalReports) {
                const rep = response.reports.find((r: IReport) => r.id === report.id);

                if(rep && rep.status !== report.status) {
                    changedReports = {
                        ...changedReports,
                        [rep.id]: rep.status,
                    }
                } else if(!rep && !report.isLocal) {
                    changedReports = {
                        ...changedReports,
                        [report.id]: ReportStatus.READY
                    }
                }

            }

            if(!isEmpty(changedReports)) {
                yield put(updateCoachReports(reports.map((r: IReport) => ({
                    ...r,
                    isLocal: false,
                    status: changedReports[r.id] || r.status,
                }))));
            }
            yield put(reportsPolling());
        }


    } catch (err) {
        handleError(err);
    }
}

function* requestDelete({payload}: {type: string, payload: string}) {
    const { reports } = yield select((state: IState) => state.coachReports);
    try {
        const filteredReports = reports.filter((el :IReport) => el.id !== payload);
        yield put(updateReports(filteredReports));
        yield call(deleteReport, payload);
    } catch (err) {
        yield put(updateReports(reports));
        handleError(err);
    }
}

export default function* MySaga(): any {
    yield all([
        yield takeEvery(CoachReportsActionTypes.ASYNC_GET_COACH_REPORTS, requestReports),
        yield takeLatest(CoachReportsActionTypes.ASYNC_GENERATE_COACH_REPORT, requestGenerateReport),
        yield takeLatest(CoachReportsActionTypes.POLLING_FOR_STATUS, pollingForStatus),
        yield takeEvery(CoachReportsActionTypes.ASYNC_DELETE_REPORT, requestDelete),
    ]);
}
